import { firebaseStorage } from '../../core/firebase';
import { showModal, hideModal, getModalProps } from '../modal';
import { UPLOAD_CHART_MODAL } from '../../components/modal/modal-types';
import FileSaver from 'file-saver';
import { startsWith } from 'lodash';

export function uploadSvg(svgData, filePath, onSuccess) {
  const blob = new Blob([svgData], {type:"image/svg+xml;charset=utf-8"});
  const storageRef = firebaseStorage.ref();
  const uploadTask = storageRef.child(filePath).put(blob);
  uploadTask.on('state_changed', function(snapshot) {
    // Handle updates
  }, function(error) {
    // Handle unsuccessful uploads
  }, function() {
    // Handle successful uploads on complete
    onSuccess(uploadTask.snapshot.downloadURL);
  });
}

export function uploadJson(json, filePath, onSuccess) {
  const blob = new Blob([JSON.stringify(json)], {type:"application/json"});
  const storageRef = firebaseStorage.ref();
  const uploadTask = storageRef.child(filePath).put(blob);
  uploadTask.on('state_changed', function(snapshot) {
    // Handle updates
  }, function(error) {
    // Handle unsuccessful uploads
  }, function() {
    // Handle successful uploads on complete
    onSuccess(uploadTask.snapshot.downloadURL);
  });
}

export function uploadDataUri(dataUri, filePath, onSuccess) {
  return dispatch => {
    const blob = dataUriToBlob(dataUri);
    const storageRef = firebaseStorage.ref();
    const uploadTask = storageRef.child(filePath).put(blob);
    
    uploadTask.on('state_changed', function(snapshot) {
      if(startsWith(filePath, 'high-res')) {
        const progress = 50 + (snapshot.bytesTransferred / snapshot.totalBytes) * 50;
        dispatch(showModal(UPLOAD_CHART_MODAL, {progress}));
      }
    }, function(error) {
      // Handle unsuccessful uploads
    }, function() {
      // Handle successful uploads on complete
      onSuccess(uploadTask.snapshot.downloadURL);
    });
  }
}

export function downloadDataUri(dataUri) {
  const blob = dataUriToBlob(dataUri);
  FileSaver.saveAs(blob, 'fanchart.jpg');
}

function dataUriToBlob(dataUri) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded dataUris - see SO answer #6850276 for code that does this
  const byteString = atob(dataUri.split(',')[1]);
  // separate out the mime component
  const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], {type: mimeString});
}


// WEBPACK FOOTER //
// ./src/core/firebase/actions.js